import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  statements: [],
  statement: false,
  loading: false,
  formLoading: false,
  exportLoading: false,
  exportSuccess: false,
  error: false,
  success: false,
  paging: false,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/BankStatement/index.js